import { useQuery } from "@tanstack/react-query";
import api from "../../../../utils/api";
import { useState } from "react";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";

export interface ServicesLideresProps {
  pgs: TInfoPg[],
  handleFilter: VoidFunction,
  alterCampos: (campo: 'sede' | 'ministerio' | 'coordenador', value: any) => void,
  reset: VoidFunction,
  dados: {
    ministerio: string | undefined,
    sede: string | undefined,
    coordenador: string | undefined
  }
 }

export type TInfoPg = {
  celula: number,
  nomecelula: string,
  ministerio: number,
  nomeministerio: string,
  sede: number,
  nomesede: string,
  frequencia: string,
  bairro: string,
  membros: number,
  idevento: number

};

const ServicesInfoPg = () => {

  const { setErrorSuccess } = useErrorSuccess()

  const [sede, setSede] = useState<string>('0');
  const [ministerio, setMinisterio] = useState<string>('0');
  const [coordenador, setCoordenador] = useState<string>('0');

  const { data: pgs = [], refetch } = useQuery({
    queryFn: () => api.get<TInfoPg[]>(`view/infos/pg/${sede}/${ministerio}/${coordenador}`),
    queryKey: ['pgs-lista'],
    select: (data) => data?.data
  });

  const getWithParams = async () => {
    try {
      await refetch()
    } catch (error) {
      setErrorSuccess({
        mensagem: error?.response?.data,
        status: 'error'
      });
    }

  }

  const reset = () => {
    setSede('0')
    setMinisterio('0')
    setCoordenador('0')
  }

  const alterCampos = (campo: 'sede' | 'ministerio' | 'coordenador', value: any) => {
    switch(campo) {
      case 'sede':
          setSede(value);
          return;

      case 'ministerio':
          setMinisterio(value);
          return;

      default:
          setCoordenador(value);
          return;
    }
  }

  return {
    pgs,
    handleFilter: getWithParams,
    alterCampos,
    reset,
    dados: {
      ministerio,
      sede,
      coordenador
    }
  };
};

export default ServicesInfoPg;
